<div class="vc-field">
   <label
      *ngIf="label"
      class="vc-label">
      {{ label }}
      <span
         *ngIf="required"
         class="required-asterisk">
         *
      </span>
   </label>
   <input
      pInputText
      [type]="type"
      [placeholder]="placeholder"
      [attr.inputmode]="inputMode"
      [attr.pattern]="pattern"
      [maxlength]="maxlength"
      [required]="required"
      [disabled]="disabled"
      [min]="min"
      [max]="max"
      [ngModel]="value"
      (ngModelChange)="handleInput($event)"
      (blur)="onTouched()"
      #ngModelCtrl="ngModel"
      [class.invalid]="required && ngModelCtrl.invalid && (ngModelCtrl.touched || ngModelCtrl.dirty)" />
   <small
      class="vc-hint"
      *ngIf="hint">
      {{ hint }}
   </small>
   <small
      *ngIf="ngModelCtrl.invalid && ngModelCtrl.touched"
      class="p-error">
      Source must have a value.
   </small>
</div>
